import "./Resources.scss";
import { ResourceData } from "./ResourceData";

const Resources = () => {
  return (
    <div className="resources">
      <div className="content">
        <h1>Additional Resources</h1>
        <div className="video-links">
          <h2>Free AI Courses</h2>
          {ResourceData.videos.map((video, index) => (
            <a
              key={index}
              href={video.link}
              target="_blank"
              rel="noopener noreferrer"
            >
              {video.title}
            </a>
          ))}
        </div>
        <div className="reading-links">
          <h2>Further Readings</h2>
          {ResourceData.readings.map((video, index) => (
            <a
              key={index}
              href={video.link}
              target="_blank"
              rel="noopener noreferrer"
            >
              {video.title}
            </a>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Resources;
